export default () => ({
  groupsetsSelfRegistration: {}
});
